import api from "@/services/api"
import type { TransactionMethod } from "./sharedTypes/transactions"

type PrepareRefundNoneDCCResponse = {
  uti: string | null
  retrievalReferenceNumber: string | null
  transactionMethod: TransactionMethod | null
  maximumRefund: number
  isDccFieldsPopulated: false
}

type PrepareRefundDCCResponse = {
  uti: string | null
  retrievalReferenceNumber: string | null
  transactionMethod: "pos_card"
  maximumRefund: number
  isDccFieldsPopulated: true
  dccCardCurrencyAmount: number
  dccCardholderCurrency: string
  dccExchangeRate: number
}

export type PrepareRefundResponse =
  | PrepareRefundNoneDCCResponse
  | PrepareRefundDCCResponse

export const prepareRefund = async (
  transactionId: string
): Promise<PrepareRefundResponse> => {
  const { body } = await api.post<PrepareRefundResponse>(
    `/transactions/${transactionId}/prepare-refund/`
  )
  return body
}
